/**
 * WellHaus — "Subscribe & Save $X.XX" buy button label  (v2 — corrected)
 * ======================================================================
 *
 * Save as: assets/subscribe-save-label.js  (replace the whole file)
 *
 * WHAT CHANGED FROM v1
 * --------------------
 * v1 read the radio inputs' checked state to decide which purchase option
 * was selected. That does not work in this theme: the radios are named
 * purchase_option_{{ 'now' | date: '%N' }}, and because that nanosecond
 * stamp is evaluated once per input, the two radios end up with DIFFERENT
 * names — so they are not a radio group and the "subscription" one stays
 * checked forever.
 *
 * v2 reads the .selected class on .purchase-option-box instead, which is
 * what the theme itself uses to track the choice.
 *
 * v2 also FAILS SAFE: if it cannot confidently determine the state, it
 * leaves the button label completely alone rather than guessing.
 *
 * Behaviour
 * ---------
 *   Subscription selected, savings > $0 .... "Subscribe & Save $6.80"
 *   Subscription selected, savings = $0 .... "Subscribe"
 *   One-time selected ...................... "Add to Tote"
 *   Sold out / unknown state ............... left alone entirely
 *
 * Savings are PER UNIT — quantity does not multiply them.
 */
(function () {
  'use strict';

  if (window.__whSubscribeSaveLabel) return;
  window.__whSubscribeSaveLabel = true;

  // -------------------------------------------------------------------
  // Edit the labels here if the copy changes.
  // -------------------------------------------------------------------
  var CONFIG = {
    subscribeLabel: 'Subscribe',
    subscribeSaveLabel: 'Subscribe & Save {amount}',
    oneTimeLabel: 'Add to Tote',
    currencySymbol: '$'
  };

  var data;
  var dataChecked = false;

  function loadData() {
    if (dataChecked) return data;
    dataChecked = true;
    var el = document.querySelector('[data-wh-subsave-data]');
    if (!el) return (data = null);
    try {
      data = JSON.parse(el.textContent);
    } catch (e) {
      data = null;
    }
    return data;
  }

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return CONFIG.currencySymbol + v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /**
   * The snippet renders twice (mobile + desktop) with nanosecond-stamped
   * IDs, so IDs cannot pair a button with its own options. Walk up to the
   * nearest ancestor that also contains a .purchase-options-toggle.
   */
  function findScope(btn) {
    var node = btn.parentElement;
    while (node && node !== document.body) {
      if (node.querySelector('.purchase-options-toggle')) return node;
      node = node.parentElement;
    }
    return null;
  }

  /**
   * Returns 'onetime', 'subscription', or null.
   * Reads the theme's own .selected class first; radios are only a
   * last-resort fallback because of the duplicate-name bug described above.
   */
  function getSelectedOption(scope) {
    var box = scope.querySelector('.purchase-option-box.selected[data-option]');
    if (box) {
      var val = box.getAttribute('data-option');
      if (val === 'onetime' || val === 'subscription') return val;
    }

    var checked = scope.querySelector('input[name^="purchase_option"]:checked');
    if (checked && (checked.value === 'onetime' || checked.value === 'subscription')) {
      return checked.value;
    }

    return null; // unknown — caller will leave the button alone
  }

  function getPlanId(scope) {
    var select = scope.querySelector('.frequency-inline-select');
    if (select && select.value) return select.value;

    var hidden = scope.querySelector('input[name="selling_plan"]');
    if (hidden && hidden.value) return hidden.value;

    return null;
  }

  function computeLabel(scope) {
    var d = loadData();
    if (!d || !d.variants) return null; // no selling plans on this product

    var option = getSelectedOption(scope);
    if (option === null) return null;              // fail safe
    if (option === 'onetime') return CONFIG.oneTimeLabel;

    var idInput = scope.querySelector('input[name="id"]');
    if (!idInput) return CONFIG.subscribeLabel;

    var variant = d.variants[idInput.value];
    if (!variant) return CONFIG.subscribeLabel;

    var plans = variant.plans || {};
    var planId = getPlanId(scope);
    var planPrice = planId !== null ? plans[planId] : undefined;

    // If the dropdown value doesn't match a known plan, fall back to the
    // product's first plan rather than dropping the savings entirely.
    if (typeof planPrice !== 'number') {
      var keys = Object.keys(plans);
      if (keys.length) planPrice = plans[keys[0]];
    }
    if (typeof planPrice !== 'number') return CONFIG.subscribeLabel;

    var savings = variant.price - planPrice;
    if (savings <= 0) return CONFIG.subscribeLabel;

    return CONFIG.subscribeSaveLabel.replace('{amount}', money(savings));
  }

  function apply() {
    var btns = document.querySelectorAll('.add-to-cart-btn-custom');

    Array.prototype.forEach.call(btns, function (btn) {
      if (btn.disabled) return; // sold out — never touch

      var scope = findScope(btn);
      if (!scope) return;

      var label = computeLabel(scope);
      if (!label) return; // couldn't determine — leave theme's label as-is

      // Only write when it differs. This is what prevents the
      // MutationObserver below from looping.
      if (btn.textContent.trim() === label) return;
      btn.textContent = label;
    });
  }

  function schedule() {
    setTimeout(apply, 80);  // let the theme's own click handlers finish
    setTimeout(apply, 300); // and again, in case it re-renders
  }

  function observeButtons() {
    if (!window.MutationObserver) return;
    var obs = new MutationObserver(function () { apply(); });
    Array.prototype.forEach.call(
      document.querySelectorAll('.add-to-cart-btn-custom'),
      function (btn) {
        obs.observe(btn, { childList: true, characterData: true, subtree: true });
      }
    );
  }

  function init() {
    if (!document.querySelector('.add-to-cart-btn-custom')) return;

    apply();
    observeButtons();

    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.classList && t.classList.contains('frequency-inline-select')) schedule();
      if (t.name && t.name.indexOf('purchase_option') === 0) schedule();
    });

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('.variant-option') || t.closest('.purchase-option-box')) schedule();
    });

    setTimeout(apply, 400);
    setTimeout(apply, 1200);
  }

  // -------------------------------------------------------------------
  // Diagnostic — run whSubSaveDebug() in the browser console if the label
  // ever looks wrong. Prints what the script is actually seeing.
  // -------------------------------------------------------------------
  window.whSubSaveDebug = function () {
    var d = loadData();
    console.log('data block found:', !!d);
    Array.prototype.forEach.call(
      document.querySelectorAll('.add-to-cart-btn-custom'),
      function (btn, i) {
        var scope = findScope(btn);
        console.log('--- button ' + i + ' ---');
        console.log('  scope found :', !!scope);
        if (!scope) return;
        var idInput = scope.querySelector('input[name="id"]');
        console.log('  option      :', getSelectedOption(scope));
        console.log('  variant id  :', idInput && idInput.value);
        console.log('  plan id     :', getPlanId(scope));
        console.log('  computed    :', computeLabel(scope));
        console.log('  current text:', btn.textContent.trim());
      }
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();